// Utility zum Verwalten des Cookie-Konsens
const CONSENT_KEY = 'cookieConsent';

export const CookieManager = {
    // Gibt zurück, ob eine Entscheidung getroffen wurde ('all', 'necessary', oder null)
    getConsentStatus: () => {
        return localStorage.getItem(CONSENT_KEY);
    },

    // Speichert die Entscheidung des Nutzers
    setConsentStatus: (status) => {
        if (status === 'all' || status === 'necessary') {
            localStorage.setItem(CONSENT_KEY, status);
        }
    },

    // Prüft, ob nicht-essenzielle (z.B. Tracking/Marketing) Cookies erlaubt sind
    hasConsentForAnalytics: () => {
        return localStorage.getItem(CONSENT_KEY) === 'all';
    },

    // Prüft, ob das Banner noch angezeigt werden muss
    needsConsent: () => {
        return localStorage.getItem(CONSENT_KEY) === null;
    }
};
